import { render, staticRenderFns } from "./DUDAttachments.vue?vue&type=template&id=8138a9b4&scoped=true&"
import script from "./DUDAttachments.vue?vue&type=script&lang=ts&"
export * from "./DUDAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./DUDAttachments.vue?vue&type=style&index=0&id=8138a9b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8138a9b4",
  null
  
)

export default component.exports